import * as React from "react";
import {
  Stack,
  Typography,
  Tooltip,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { useMarketsState } from "src/store/features/markets.slice";

export default function CoinPermissions() {
  const toolTip =
    "Here you may find the type of transactions you are able to make with this coin i.e trade, deposit, withdraw.";
  const {
    coinStatistics: { currencyConfig },
  } = useMarketsState();

  const permissions: any = currencyConfig?.permissions;
  return (
    <Grid container>
      <Grid item xs={12}>
        <Stack direction={"row"} alignItems={"center"} marginBottom={"8px"}>
          <Typography fontSize={"16px"}>You can </Typography>
          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  background: "#002035",
                  fontSize: "14px",
                },
              },
            }}
            title={toolTip}>
            <InfoOutlinedIcon sx={{ fontSize: "16px", paddingLeft: "2px" }}></InfoOutlinedIcon>
          </Tooltip>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ padding: "12px", borderRadius: "10px", background: "#F8F9F9" }}>
          {permissions !== undefined &&
            Object.keys(permissions).map((key, index) => (
              <FormGroup key={index}>
                <FormControlLabel
                  disabled
                  control={
                    <Checkbox
                      checked={permissions[key]}
                      checkedIcon={<CheckCircleRoundedIcon />}
                      icon={<CancelRoundedIcon />}
                      sx={{
                        "&.Mui-checked": {
                          color: "#000",
                        },
                        "& .MuiSvgIcon-root": { fontSize: 16 },
                      }}
                    />
                  }
                  label={<Typography sx={{ textTransform: "capitalize" }}>{key}</Typography>}
                />
              </FormGroup>
            ))}
        </Stack>
      </Grid>
    </Grid>
  );
}
